import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { TRANSITIONS } from '../../util/customTransaction/mainRentalTransaction';
import { queryTransactionsPrivileged } from '../../util/api';

const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );

// ================ Action types ================ //

export const FETCH_TRANSACTIONS_REQUEST =
  'app/AdminManageTransactionsPage/FETCH_TRANSACTIONS_REQUEST';
export const FETCH_TRANSACTIONS_SUCCESS =
  'app/AdminManageTransactionsPage/FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'app/AdminManageTransactionsPage/FETCH_TRANSACTIONS_ERROR';
// ================ Reducer ================ //

const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

const initialState = {
  fetchInProgress: false,
  fetchError: null,
  pagination: {
    totalPages: 0,
  },
  transactionRefs: [],
};

export default function adminManageTransactionsReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_TRANSACTIONS_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_TRANSACTIONS_SUCCESS: {
      const transactions = sortedTransactions(payload.data.data);
      return {
        ...state,
        fetchInProgress: false,
        transactionRefs: entityRefs(transactions),
        pagination: payload.data.meta,
      };
    }
    case FETCH_TRANSACTIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchRequest = () => ({ type: FETCH_TRANSACTIONS_REQUEST });
const fetchSuccess = response => ({
  type: FETCH_TRANSACTIONS_SUCCESS,
  payload: response,
});
const fetchError = e => ({
  type: FETCH_TRANSACTIONS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

const INBOX_PAGE_SIZE = 10;

export const loadTransactions = params => (dispatch, getState, sdk) => {
  dispatch(fetchRequest());

  if (typeof window === 'undefined') {
    return dispatch(fetchSuccess({ data: [] }));
  }

  const {
    page = 1,
    perPage,
    transactionId,
    userId,
    listingId,
    providerId,
    customerId,
    lastTransition,
  } = params;

  const apiQueryParams = {
    page,
    per_page: perPage || INBOX_PAGE_SIZE,
    ...(transactionId ? { transactionId } : {}),
    ...(userId ? { userId } : {}),
    ...(providerId ? { providerId } : {}),
    ...(customerId ? { customerId } : {}),
    ...(listingId ? { listingId } : {}),
    ...(lastTransition ? { lastTransition } : {}),
  };

  return queryTransactionsPrivileged(apiQueryParams)
    .then(response => {
      dispatch(addMarketplaceEntities(response.data));
      dispatch(fetchSuccess(response.data));
      return response.data;
    })
    .catch(e => {
      dispatch(fetchError(storableError(e)));
      throw e;
    });
};
